import { GtkmActionTypes } from './action-types';
export const setGtkmAnimationStart = () => dispatch => dispatch({
  type: GtkmActionTypes.SetAnimationStart
});
export const setGtkmAnimationStop = () => dispatch => dispatch({
  type: GtkmActionTypes.SetAnimationStop
});
export const setGtkmAnimationNotDisplayed = () => dispatch => dispatch({
  type: GtkmActionTypes.SetAnimationNotDisplayed
});
export const setGtkmShowingErrorModal = showingErrorModal => dispatch => dispatch({
  type: GtkmActionTypes.SetShowingErrorModal,
  showingErrorModal
});
export const setGtkmAnimationShowingCount = animationShowingCount => dispatch => dispatch({
  type: GtkmActionTypes.SetAnimationShowingCount,
  animationShowingCount
});
export const setGtkmHasDomainChangedInDomainStep = hasDomainChangedInDomainStep => dispatch => dispatch({
  type: GtkmActionTypes.SetHasDomainChangedInDomainStep,
  hasDomainChangedInDomainStep
});